// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var StarRating$ReactHooksTemplate = require("./StarRating.res.js");

function colorForValue(colorRanges, value) {
  var range = Belt_List.getBy(colorRanges, (function (range) {
          if (value >= range.min) {
            return value <= range.max;
          } else {
            return false;
          }
        }));
  if (range !== undefined) {
    return range.color;
  } else {
    return "#7E909A";
  }
}

function starCount(minRating, maxRating) {
  return (maxRating - minRating | 0) + 1 | 0;
}

function sizeClasses(count, layout) {
  if (layout === "Editor") {
    if (count > 8) {
      return "h-10 w-10";
    } else if (count > 6) {
      return "h-12 w-12";
    } else if (count > 5) {
      return "h-14 w-14";
    } else {
      return "h-72-px w-72-px";
    }
  } else if (count > 8) {
    return "h-10 w-10 small:h-6 small:w-6";
  } else if (count > 6) {
    return "h-12 w-12 small:h-8 small:w-8";
  } else if (count > 5) {
    return "h-12 w-12 small:h-9 small:w-9";
  } else {
    return "h-16 w-16 small:h-10 small:w-10";
  }
}

function itemSpacing(count, layout) {
  if (layout === "Editor") {
    if (count > 8) {
      return "mx-1 flex-shrink-0";
    } else if (count > 5) {
      return "mx-2 flex-shrink-0";
    } else {
      return "mr-4 flex-shrink-0 last:mr-0";
    }
  } else if (count > 8) {
    return "mx-0.5 small:mx-0.5 flex-shrink-0";
  } else if (count > 5) {
    return "mx-1 small:mx-0.5 flex-shrink-0";
  } else {
    return "mx-2 small:mx-1 flex-shrink-0";
  }
}

function wrapperClass(layout) {
  if (layout === "Editor") {
    return "w-full flex justify-start pb-4";
  } else {
    return "w-full flex justify-center pt-4 pb-10";
  }
}

function rowClass(layout) {
  if (layout === "Editor") {
    return "star-rating-scale-row star-rating-scale-row--editor";
  } else {
    return "star-rating-scale-row star-rating-scale-row--survey";
  }
}

function StarRatingScale(props) {
  var __layout = props.layout;
  var onChange = props.onChange;
  var starRating = props.starRating;
  var layout = __layout !== undefined ? __layout : "Survey";
  var minRating = StarRating$ReactHooksTemplate.minRating(starRating);
  var maxRating = StarRating$ReactHooksTemplate.maxRating(starRating);
  var colorRanges = StarRating$ReactHooksTemplate.colorRanges(starRating);
  var selectedRating = StarRating$ReactHooksTemplate.selectedRating(starRating);
  var count = starCount(minRating, maxRating);
  var starClass = sizeClasses(count, layout);
  var spacingClass = itemSpacing(count, layout);
  var hasSelection = selectedRating >= minRating;
  var selectedColor = hasSelection ? colorForValue(colorRanges, selectedRating) : colorForValue(colorRanges, minRating);
  var loop = function (_current, _acc) {
    while(true) {
      var acc = _acc;
      var current = _current;
      if (current > maxRating) {
        return Belt_List.reverse(acc);
      }
      _acc = {
        hd: current,
        tl: acc
      };
      _current = current + 1 | 0;
      continue ;
    };
  };
  var values = loop(minRating, /* [] */0);
  var stars = $$Array.of_list(Belt_List.mapWithIndex(values, (function (index, value) {
              var isFilled = hasSelection && value <= selectedRating;
              var starColor = isFilled ? selectedColor : colorForValue(colorRanges, value);
              return JsxRuntime.jsx("a", {
                          children: JsxRuntime.jsxs("svg", {
                                children: [
                                  JsxRuntime.jsx("text", {
                                        children: String(value),
                                        fill: starColor,
                                        fontSize: "5.5",
                                        fontWeight: "600",
                                        textAnchor: "middle",
                                        x: "8",
                                        y: "10.5"
                                      }),
                                  JsxRuntime.jsx("g", {
                                        children: isFilled ? JsxRuntime.jsx("polygon", {
                                                fill: starColor,
                                                points: "8.00003333 1 5.8374897 5.60788861 1 6.34709213 4.50095 9.93484254 3.67401273 15.0000667 8.00003333 12.6088553 12.3260539 15.0000667 11.50005 9.93484254 15.001 6.34709213 10.1635103 5.60788861"
                                              }) : JsxRuntime.jsx("path", {
                                                d: "M8,1 L5.836,5.609 L1,6.348 L4.5,9.935 L3.674,15 L8,12.609 L12.326,15 L11.5,9.935 L15,6.348 L10.163,5.609 L8,1 Z M5.486,10.096 L5.568,9.598 L5.215,9.237 L3.074,7.043 L5.988,6.598 L6.515,6.517 L6.742,6.034 L8,3.354 L9.257,6.034 L9.484,6.517 L10.012,6.598 L12.925,7.043 L10.784,9.237 L10.432,9.598 L10.513,10.096 L11.008,13.129 L8.483,11.733 L8,11.466 L7.516,11.733 L4.992,13.129 L5.486,10.096 Z",
                                                fill: starColor
                                              }),
                                        fill: "none",
                                        fillRule: "evenodd",
                                        stroke: "none",
                                        strokeWidth: "1"
                                      })
                                ],
                                className: starClass,
                                version: "1.1",
                                viewBox: "0 0 16 16",
                                xmlns: "http://www.w3.org/2000/svg"
                              }),
                          className: "focus:outline-none " + spacingClass,
                          href: "#",
                          onClick: (function ($$event) {
                              $$event.preventDefault();
                              Curry._1(onChange, StarRating$ReactHooksTemplate.setAnswerInt(starRating, value));
                            })
                        }, String(index));
            })));
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: stars,
                    className: rowClass(layout)
                  }),
              className: wrapperClass(layout)
            });
}

var make = StarRatingScale;

exports.colorForValue = colorForValue;
exports.starCount = starCount;
exports.sizeClasses = sizeClasses;
exports.itemSpacing = itemSpacing;
exports.wrapperClass = wrapperClass;
exports.rowClass = rowClass;
exports.make = make;
/* react/jsx-runtime Not a pure module */
